const styles = {
  deleteButton: {
    marginRight: 'auto !important'
  }
}

export default styles
